
const IN_APP_PATTERNS = [
  'FBAN',    // Facebook App
  'FBAV',    // Facebook App Version
  'FB_IAB',  // Facebook In-App Browser
  'Instagram',
  'Line/',
  'Twitter',
  'KAKAOTALK',
];

const patternRegex = new RegExp(IN_APP_PATTERNS.join('|'), 'i');

/**
 * Detects whether the current browser is a Meta/social in-app WebView.
 * Cached at module load so it can be used synchronously everywhere.
 */
export const isInAppBrowser: boolean =
  typeof navigator !== 'undefined' && patternRegex.test(navigator.userAgent);
